// extracted by mini-css-extract-plugin
export default {"footerText":"Footer_footerText__Wrh98","footer":"Footer_footer__RMvem"};